// // ----------------- DEBUG PURCHASE & INITIATE CHECKOUT SCRIPT -----------------

// // Helper to log every _tfa.push call
// (function() {
//   const originalPush = Array.prototype.push;
//   window._tfa = window._tfa || [];
//   const tfa = window._tfa;
//   tfa.push = function() {
//     console.log("Taboola _tfa.push called with:", arguments);
//     return originalPush.apply(tfa, arguments);
//   };
// })();

// // Breeze purchase event listener
// window.addEventListener("breeze-purchase", (event) => {
//   console.log("Breeze purchase event fired!", event.detail);
//   breezePurchase(event.detail);
// });

// // Breeze initiate checkout event listener
// window.addEventListener("breeze-initiate-checkout", (event) => {
//   console.log("Breeze initiate checkout event fired!", event.detail);
//   breezeInitiateCheckout(event.detail);
// });

// // Breeze purchase handler
// function breezePurchase(payload) {
//   try {
//     merchantPurchaseCustomCode(payload.data);
//   } catch (e) {
//     console.log("Error in triggering merchant purchase script:", e);
//   }
// }

// // Breeze initiate checkout handler
// function breezeInitiateCheckout(payload) {
//   try {
//     merchantInitiateCheckoutCustomCode(payload.data);
//   } catch (e) {
//     console.log("Error in triggering merchant initiate checkout script:", e);
//   }
// }

// // Taboola purchase event
// function merchantPurchaseCustomCode(params) {
//   window._tfa = window._tfa || [];
//   _tfa.push({ 
//     notify: 'event', 
//     name: 'purchase', 
//     id: "1953823",
//     revenue: params.totalPrice,
//     currency: "INR",
//     orderId: params.shopOrderId,
//     triggered_by: "Breeze"
//   });

//   loadTaboolaScript();
// }

// // Taboola initiate checkout event
// function merchantInitiateCheckoutCustomCode(params) {
//   window._tfa = window._tfa || [];
//   _tfa.push({
//     notify: 'event',
//     name: 'initiate_checkout',
//     id: "1953823",
//     revenue: params.totalPrice,
//     currency: "INR",
//     orderId: params.shopOrderId,
//     triggered_by: "Breeze"
//   });

//   loadTaboolaScript();
// }

// // Load Taboola script once
// function loadTaboolaScript() {
//   if (!document.getElementById('tb_tfa_script')) {
//     const s = document.createElement('script');
//     s.async = true;
//     s.src = '//cdn.taboola.com/libtrc/unipixel/1953823/tfa.js';
//     s.id = 'tb_tfa_script';
//     document.getElementsByTagName('script')[0].parentNode.insertBefore(s, document.getElementsByTagName('script')[0]);
//     console.log("Taboola script loaded");
//   }
// }

// // ----------------- MANUAL SIMULATION ----------------------
// function simulateAllBreezeEvents() {
//   console.log("---- Simulating all Breeze events ----");

//   // Simulate initiate checkout
//   window.dispatchEvent(new CustomEvent("breeze-initiate-checkout", {
//     detail: { data: { totalPrice: 1000, shopOrderId: "TEST123" } }
//   }));

//   // Simulate purchase
//   window.dispatchEvent(new CustomEvent("breeze-purchase", {
//     detail: { data: { totalPrice: 1000, shopOrderId: "TEST123" } }
//   }));
// }

// // Usage: open console and run simulateAllBreezeEvents();


// // ----------------- DEBUG PURCHASE & INITIATE CHECKOUT SCRIPT (fixed) -----------------

// (function() {
//   // Safe _tfa wrapper + push logger
//   const originalPush = Array.prototype.push;
//   window._tfa = window._tfa || [];
//   const tfa = window._tfa;

//   // Only override push if not already overridden by Taboola
//   if (!tfa.__loggedPush) {
//     tfa.push = function() {
//       try {
//         console.log("Taboola _tfa.push called with:", arguments);
//       } catch(e) {
//         console.warn("Error logging _tfa.push args", e);
//       }
//       return originalPush.apply(tfa, arguments);
//     };
//     // marker so we don't wrap multiple times
//     tfa.__loggedPush = true;
//   }
// })();

// // Breeze purchase event listener
// window.addEventListener("breeze-purchase", (event) => {
//   console.log("Breeze purchase event fired!", event.detail);
//   breezePurchase(event.detail);
// });

// // Breeze initiate checkout event listener
// window.addEventListener("breeze-initiate-checkout", (event) => {
//   console.log("Breeze initiate checkout event fired!", event.detail);
//   breezeInitiateCheckout(event.detail);
// });

// // Breeze purchase handler
// function breezePurchase(payload) {
//   try {
//     merchantPurchaseCustomCode(payload.data);
//   } catch (e) {
//     console.error("Error in triggering merchant purchase script:", e);
//   }
// }

// // Breeze initiate checkout handler
// function breezeInitiateCheckout(payload) {
//   try {
//     merchantInitiateCheckoutCustomCode(payload.data);
//   } catch (e) {
//     console.error("Error in triggering merchant initiate checkout script:", e);
//   }
// }

// // Taboola purchase event
// function merchantPurchaseCustomCode(params) {
//   if (!params) { console.warn("merchantPurchaseCustomCode called with no params"); return; }
//   window._tfa = window._tfa || [];
//   _tfa.push({ 
//     notify: 'event', 
//     name: 'purchase', 
//     id: "1953823",
//     revenue: params.totalPrice,
//     currency: "INR",
//     orderId: params.shopOrderId,
//     triggered_by: "Breeze"
//   });

//   loadTaboolaScript();
// }

// // Taboola initiate checkout event
// function merchantInitiateCheckoutCustomCode(params) {
//   if (!params) { console.warn("merchantInitiateCheckoutCustomCode called with no params"); return; }
//   window._tfa = window._tfa || [];
//   _tfa.push({
//     notify: 'event',
//     name: 'initiate_checkout',
//     id: "1953823",
//     revenue: params.totalPrice,
//     currency: "INR",
//     orderId: params.shopOrderId,
//     triggered_by: "Breeze"
//   });

//   loadTaboolaScript();
// }

// // Load Taboola script once (robust insertion)
// function loadTaboolaScript() {
//   try {
//     if (!document.getElementById('tb_tfa_script')) {
//       const s = document.createElement('script');
//       s.async = true;
//       s.src = (location.protocol === 'file:' ? 'https://cdn.taboola.com/libtrc/unipixel/1953823/tfa.js' : '//cdn.taboola.com/libtrc/unipixel/1953823/tfa.js');
//       s.id = 'tb_tfa_script';
//       if (document.head) {
//         document.head.appendChild(s);
//       } else {
//         // fallback
//         document.getElementsByTagName('script')[0]?.parentNode?.insertBefore(s, document.getElementsByTagName('script')[0]);
//       }
//       console.log("Taboola script insertion attempted");
//     }
//   } catch (err) {
//     console.error("Error inserting Taboola script:", err);
//   }
// }

// // ----------------- MANUAL SIMULATION ----------------------
// function simulateAllBreezeEvents() {
//   console.log("---- Simulating all Breeze events ----");

//   // Simulate initiate checkout
//   window.dispatchEvent(new CustomEvent("breeze-initiate-checkout", {
//     detail: { data: { totalPrice: 1000, shopOrderId: "TEST123" } }
//   }));

//   // Simulate purchase
//   window.dispatchEvent(new CustomEvent("breeze-purchase", {
//     detail: { data: { totalPrice: 1000, shopOrderId: "TEST123" } }
//   }));
// }

// // Usage: open console and run simulateAllBreezeEvents();





// ----------------- DEBUG + SAFE _tfa WRAPPER -----------------

(function() {
  const originalPush = Array.prototype.push;
  window._tfa = window._tfa || [];
  const tfa = window._tfa;

  if (!tfa.__loggedPush) {
    tfa.push = function() {
      try { console.log("Taboola _tfa.push called with:", arguments); } catch(e) {}
      return originalPush.apply(tfa, arguments);
    };
    tfa.__loggedPush = true;
  }
})();

// ----------------- BREEZE → CUSTOM EVENTS -----------------

// Breeze Purchase → Dispatch Taboola Event
window.addEventListener("breeze-purchase", (event) => {
  console.log(" Breeze PURCHASE fired:", event.detail);

  window.dispatchEvent(new CustomEvent("taboola-purchase", {
    detail: event.detail.data
  }));
});

// Breeze Initiate Checkout → Dispatch Taboola Event
window.addEventListener("breeze-initiate-checkout", (event) => {
  console.log(" Breeze INITIATE CHECKOUT fired:", event.detail);

  window.dispatchEvent(new CustomEvent("taboola-initiate-checkout", {
    detail: event.detail.data
  }));
});


// ----------------- TABOOLA + GTM HANDLERS (EVENT BASED) -----------------

// PURCHASE HANDLER
window.addEventListener("taboola-purchase", (event) => {
  const params = event.detail;
  console.log(" Taboola PURCHASE event received:", params);

  // --- Push to GTM dataLayer ---
  window.dataLayer = window.dataLayer || [];
  dataLayer.push({
    event: "purchase",
    revenue: params.totalPrice,
    orderId: params.shopOrderId,
    source: "breeze"
  });
  console.log("📤 GTM dataLayer purchase pushed:", params);

  // --- Push to Taboola ---
  window._tfa = window._tfa || [];
  _tfa.push({
    notify: "event",
    name: "purchase",
    id: "1953823",
    revenue: params.totalPrice,
    currency: "INR",
    orderId: params.shopOrderId
  });

  // Load Taboola script
  window.dispatchEvent(new Event("taboola-load-script"));
});


// INITIATE CHECKOUT HANDLER
window.addEventListener("taboola-initiate-checkout", (event) => {
  const params = event.detail;
  console.log("Taboola INITIATE CHECKOUT event received:", params);

  // --- Push to GTM dataLayer ---
  window.dataLayer = window.dataLayer || [];
  dataLayer.push({
    event: "initiate_checkout",
    revenue: params.totalPrice,
    orderId: params.shopOrderId,
    source: "breeze"
  });
  console.log("📤 GTM dataLayer initiate_checkout pushed:", params);

  // --- Push to Taboola ---
  window._tfa = window._tfa || [];
  _tfa.push({
    notify: "event",
    name: "initiate_checkout",
    id: "1953823",
    revenue: params.totalPrice,
    currency: "INR",
    orderId: params.shopOrderId
  });

  // Load Taboola script
  window.dispatchEvent(new Event("taboola-load-script"));
});


// ----------------- LOAD TABOOLA SCRIPT ONCE -----------------

window.addEventListener("taboola-load-script", () => {
  try {
    if (!document.getElementById("tb_tfa_script")) {
      const s = document.createElement("script");
      s.async = true;
      s.src = "//cdn.taboola.com/libtrc/unipixel/1953823/tfa.js";
      s.id = "tb_tfa_script";
      document.head.appendChild(s);
      console.log("📥 Taboola script loaded.");
    }
  } catch (err) {
    console.error("Error loading Taboola script:", err);
  }
});

